import React, { useEffect } from "react";
import { getHealth } from "./health.service";
import { Route } from "../../common/Navigation";
import { ErrorCode } from "../../common/ErrorInformation";
import * as H from 'history';

let health: Promise<{ maintenanceMode: boolean }> | undefined = undefined;

export type HealthCheckProps = {
  history: H.History;
  onHealth: () => void;
  children: React.ReactNode[] | React.ReactNode[];
};

export function HealthCheck({ history, onHealth, children }: HealthCheckProps) {
  const [isLoading, setLoading] = React.useState(true);

  useEffect(() => {
    if (!health) {
      // we need to call this only once, see FLGFT-1788
      health = getHealth();
    }
    if (isLoading) {
      health
        .then((response) => {
          if (response.maintenanceMode !== true) {
            onHealth();
          }
          setLoading(false);
        })
        .catch(() => {
          history.push(Route.Error, {
            errorCode: ErrorCode.HealthCheckError,
          });
        });
    }
  }, [history, isLoading, onHealth]);

  return (
    <>
      {isLoading && <></>}
      {!isLoading && children}
    </>
  );
}
